<!-- <div class="css-Floating_Button_Asistente floating_button_asistente">
    <button class="css-button_Floating_Button_Asistente button_floating_button_asistente">
        <img src="assets/images/basecomponents-images/vectors60225820.svg" width="70px" height="70px"
            class="css-Vector_Ellipse_1 vector_ellipse_1">
        <img [src]="obtenerIconoAsistente()" width="26px" height="30.588256835938px"
            class="css-Vector_Icono_Asistente vector_icono_asistente">
    </button>
</div> -->

<div class="floating_button_asistencia">
    <button id="button_floating_button" class="button_floating_button">
        <div class="icono_asistencia_flotante">
            <img [src]="obtenerIconoAsistente()" width="33.60986328125px" height="26.93115234375px" class="vector">
        </div>
    </button>
</div>